import "./css/modern-normalize.css";
import "./css/main-style.css";
import { displayProject } from "./js/UI";
import { fetchRepos } from "./js/data";

(async () => {
  const repos = await fetchRepos();
  repos.forEach((repo) => {
    displayProject(repo);
  });
  //   console.log(repos);
})();
